// AddViewSupport48Component.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import { Formik, Field, Form, FieldArray } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { BsPlusCircle } from "react-icons/bs";
import DatePicker, { registerLocale } from "react-datepicker";
import { utcToZonedTime } from "date-fns-tz";
import { format, parseISO } from "date-fns";
import th from "date-fns/locale/th";
import { th as thBuddhist } from "date-fns/esm/locale";
import { addYears } from "date-fns/esm/fp";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";

registerLocale("th-buddhist", {
  ...th,
  options: { ...th.options, weekStartsOn: 1 },
  formatLong: thBuddhist.formatLong,
});

const thaiMonths = [
  "มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน",
  "กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม",
];
const range = (start, end) => new Array(end - start).fill().map((_, i) => i + start);
const years = range(1963, new Date().getFullYear() + 8);

function formatMonthYearBE(date) {
  if (!date) return "";
  const be = addYears(543, date);
  return format(be, "MMMM yyyy", { locale: th });
}
function fmtMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function toThaiDateLabel(iso) {
  if (!iso) return "-";
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  const be = addYears(543, d);
  const monthName = format(be, "MMMM", { locale: th });
  return `${format(be, "dd")} ${monthName} ${format(be, "yyyy")}`;
}
function parseYearMonth(yyyymm) {
  const [y, m] = (yyyymm || "").split("-").map((v) => Number(v));
  return { y, m };
}
function sameMonth(iso, y, m) {
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  return d.getFullYear() === y && (d.getMonth() + 1) === m;
}

export function AddViewSupport47Component() {
  const [reportMonth, setReportMonth] = useState("");
  const [reportMonthDate, setReportMonthDate] = useState(null);
  const user = JSON.parse(localStorage.getItem("userData") || "{}");
  const deptId = user?.deptId || "";

  const [budgetAllowCate, setBudgetAllowCate] = useState(0);
  const [loading, setLoading] = useState(false);

  const [lawOcuData, setLawOcuData] = useState([]);
  const [summarySpendAlowcate, setSummarySpendAllowcate] = useState(0);
  const [summaryEvaAlowcate, setSummaryEvaAllowcate] = useState(0);

  const [items, setItems] = useState([]); // แถวที่โชว์ในตารางหลัก (detail-based)
  const [allocatedBudget, setAllocatedBudget] = useState(0);
  const [isEditingReport, setIsEditingReport] = useState(false);

  // ===== Modal state
  const [openModal, setOpenModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  // ===== Cache ตัวเลือก "สาขา" แยกตาม lawOccupationId (ใช้ที่ parent)
  const [testOccCache, setTestOccCache] = useState({});

  // ===== Helper: โหลดตัวเลือกสาขาที่ parent (จะส่งฟังก์ชันนี้ลงไปใน ItemForm)
  const fetchTestOptionsAtParent = async (lawOccId) => {
    if (!lawOccId) return [];
    if (testOccCache[lawOccId]) return testOccCache[lawOccId];
    try {
      const fd = new FormData();
      fd.append("lawOcuId", lawOccId);
      const res = await fetch("/api/Borrow/getLawOcuDataDetail", { method: "POST", body: fd });
      const j = await res.json();
      const opts = j?.dataenum || [];
      setTestOccCache(prev => ({ ...prev, [lawOccId]: opts }));
      return opts;
    } catch {
      return [];
    }
  };

  // ===== API: งบเดือน
  useEffect(() => {
    const getBudgetAllowCate = async () => {
      try {
        if (!reportMonth) return;
        let res = await fetch(`/api/Support/getBudgetAllowCate/${reportMonth}/${user.deptId}`)
        let resJson = await res.json();
        setBudgetAllowCate(resJson.dataenum);
      } catch (e) { console.log("err", e) }
    }
    getBudgetAllowCate();
  }, [reportMonth, user.deptId]);

  // ===== Master: สาขาอาชีพ
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await fetch("/api/Borrow/getLawOcuData");
        const j = await res.json();
        setLawOcuData(j?.dataenum || []);
      } catch { } finally { setLoading(false); }
    })();
  }, []);

  // ===== โหลดรายเดือน + แปลงเป็นแถว detail
  const checkAndLoadMonth = async () => {
    if (!reportMonth || !deptId) {
      Swal.fire("กรุณาเลือกรอบรายงาน (เดือน/ปี)", "", "warning");
      return;
    }
    try {
      setLoading(true);
      const q = new URLSearchParams({ monthYear: reportMonth, deptId });
      const res = await fetch(`/api/Support/getViewdata48?${q.toString()}`);
      const j = await res.json();
      if (j?.status !== 1) throw new Error(j?.message || "ไม่สามารถโหลดข้อมูลได้");

      const rows = (j?.dataenum || []).map((s) => ({
        id: s.id,
        deptId: s.deptId,
        lawOccupationId: s.lawOccupationId,
        lawOccupationName: s.lawOccupationName,
        testOccupationId: s.testOccupationId,
        testOccupatioName: s.testOccupatioName,
        testOccupationLevel: s.testOccupationLevel || "1",
        personTest: Number(s.personTest || 0),
        passEvaluation: Number(s.passEvaluation || 0),
        evaluatorExpense: Number(s.evaluatorExpense || 0),
        compensetionExpense: Number(s.compensationExpense || 0),
        travellingExpense: Number(s.travellingExpense || 0),
        materialExpense: Number(s.materialExpense || 0),
        paymentDate: s.paymentDate,
        createBy: s.createBy || "",
      }));

      setItems(rows);
      setAllocatedBudget(0);
      setIsEditingReport(rows.length > 0);
    } catch (e) {
      console.error(e);
      Swal.fire("โหลดข้อมูลเดือนไม่สำเร็จ", e?.message || "", "error");
      setItems([]);
      setAllocatedBudget(0);
      setIsEditingReport(false);
    } finally { setLoading(false); }
  };

  // ===== สรุปอื่น ๆ
  useEffect(() => {
    const getSpendAllowCate = async () => {
      try {
        if (!reportMonth) return;
        let res = await fetch(`/api/Support/getSpendAllowCate/${reportMonth}/${user.deptId}`)
        let resJson = await res.json();
        setSummarySpendAllowcate(resJson.dataenum);
      } catch (e) { console.log("err", e) }
    }
    getSpendAllowCate();
  }, [reportMonth, user.deptId]);

  useEffect(() => {
    const getEvaluateAllowCate = async () => {
      try {
        if (!reportMonth) return;
        let res = await fetch(`/api/Support/getEvaluateAllowCate/${reportMonth}/${user.deptId}`)
        let resJson = await res.json();
        setSummaryEvaAllowcate(resJson.dataenum);
      } catch (e) { console.log("err", e) }
    }
    getEvaluateAllowCate();
  }, [reportMonth, user.deptId]);

  // ===== จัดรูปแสดงตารางหลัก: group ตาม id → flat พร้อม rowSpan
  const groups = useMemo(() => {
    const map = new Map();
    for (const r of items) {
      const id = String(r.id ?? r.Id ?? "");
      if (!map.has(id)) map.set(id, []);
      map.get(id).push(r);
    }
    for (const [k, arr] of map.entries()) {
      arr.sort((a, b) => (a.lawOccupationName || "").localeCompare(b.lawOccupationName || "", "th"));
    }
    return Array.from(map.values());
  }, [items]);

  const flatRows = useMemo(() => {
    const out = [];
    for (const arr of groups) {
      arr.forEach((row, idx) => {
        out.push({ ...row, _isFirst: idx === 0, _rowSpan: arr.length });
      });
    }
    return out;
  }, [groups]);

  const totals = useMemo(() => {
    const person = items.reduce((a, r) => a + Number(r.personTest || 0), 0);
    const pass   = items.reduce((a, r) => a + Number(r.passEvaluation || r.passevaluaTion || 0), 0);

    let evalTot = 0, compTot = 0, travTot = 0, matTot = 0;
    for (const arr of groups) {
      const h = arr[0] || {};
      evalTot += Number(h.evaluatorExpense    || 0);
      compTot += Number(h.compensetionExpense || 0);
      travTot += Number(h.travellingExpense   || 0);
      matTot  += Number(h.materialExpense     || 0);
    }
    const sumTot = evalTot + compTot + travTot + matTot;
    return { person, pass, evalTot, compTot, travTot, matTot, sumTot };
  }, [items, groups]);

  // const summary = useMemo(() => {
  //   const spent = totals.sumTot;
  //   const remaining = Math.max(Number(allocatedBudget || 0) - spent, 0);
  //   const passed = totals.pass;
  //   return { spent, passed, remaining };
  // }, [totals, allocatedBudget]);

  // ===== Helper: ชื่อสาขาอาชีพ
  const getLawOccName = (id) =>
    lawOcuData.find((x) => String(x.lawOccupationId) === String(id))?.lawOccupationName || "-";

  // ===== เดือน UI
  useEffect(() => {
    if (!reportMonth) { setReportMonthDate(null); return; }
    const [y, m] = reportMonth.split("-").map(Number);
    setReportMonthDate(new Date(y, m - 1, 1));
  }, [reportMonth]);

  // ===== รวมแถวด้วย id สำหรับเปิดแก้ไข + preload ตัวเลือกสาขา
  function buildEditPayload(headerId) {
    const same = items.filter(x => String(x.id ?? x.Id) === String(headerId));
    if (same.length === 0) return null;
    const h = same[0];
    return {
      id: h.id || h.Id,
      deptId,
      paymentDate: h.paymentDate || "",
      evaluatorExpense: Number(h.evaluatorExpense || 0),
      compensetionExpense: Number(h.compensetionExpense || 0),
      travellingExpense: Number(h.travellingExpense || 0),
      materialExpense: Number(h.materialExpense || 0),
      createBy: h.createBy || "",
      detailRows: same.map(r => ({
        lawOccupationId: r.lawOccupationId || "",
        testOccupationId: r.testOccupationId || "",
        personTest: Number(r.personTest || 0),
        passEvaluation: Number(r.passEvaluation || r.passevaluaTion || 0),
        testOccupationLevel: r.testOccupationLevel || "1",
      })),
    };
  }

  const openAdd = () => { setEditingItem(null); setOpenModal(true); };

  const openEdit = async (row) => {
    const headerId = row.id || row.Id;
    const payload = buildEditPayload(headerId);
    if (!payload) return;

    // preload สาขาให้ครบทุก lawOccupationId ก่อนเปิด modal
    const ids = Array.from(new Set(payload.detailRows.map(r => r.lawOccupationId).filter(Boolean)));
    await Promise.all(ids.map(fetchTestOptionsAtParent));

    setEditingItem(payload);
    setOpenModal(true);
  };

  const closeModal = () => setOpenModal(false);

  return (
    <Container className="py-3">

      <Row className="g-3 align-items-end">
        <Col md={5}>
          <Label>รอบรายงาน (เดือน/ปี)</Label>
          <DatePicker
            selected={reportMonthDate}
            onChange={(date) => {
              if (date instanceof Date && !isNaN(date)) {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, "0");
                setReportMonth(`${y}-${m}`);
                setReportMonthDate(new Date(y, Number(m) - 1, 1));
              } else {
                setReportMonth("");
                setReportMonthDate(null);
              }
            }}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            showFullMonthYearPicker
            locale="th-buddhist"
            placeholderText="เลือกเดือน/ปี (พ.ศ.)"
            value={formatMonthYearBE(reportMonthDate)}
            renderCustomHeader={({
              date, changeYear, changeMonth,
              decreaseMonth, increaseMonth,
              prevMonthButtonDisabled, nextMonthButtonDisabled,
            }) => (
              <div className="d-flex justify-content-between align-items-center px-2 py-1" style={{ gap: 8 }}>
                <button type="button" className="btn btn-sm btn-light" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>‹</button>
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <select className="form-select form-select-sm" style={{ width: 120 }}
                          value={thaiMonths[getMonth(date)]}
                          onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}>
                    {thaiMonths.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                  <select className="form-select form-select-sm" style={{ width: 100 }}
                          value={getYear(date)}
                          onChange={({ target: { value } }) => changeYear(Number(value))}>
                    {years.map((y) => (<option key={y} value={y}>{y + 543}</option>))}
                  </select>
                </div>
                <button type="button" className="btn btn-sm btn-light" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>›</button>
              </div>
            )}
            customInput={
              <input className="form-control rounded-pill text-center input-color" readOnly
                     value={formatMonthYearBE(reportMonthDate)}
                     placeholder="เลือกเดือน/ปี (พ.ศ.)" />
            }
          />
        </Col>

        <Col md="auto" className="pt-4">
          <button className="btn btn-primary" onClick={checkAndLoadMonth} disabled={!reportMonth}>
            ตรวจสอบ/โหลดรายงาน
          </button>
        </Col>

        <Col md="auto" className="pt-4">
          {reportMonth && (
            <span className={`badge ${isEditingReport ? "bg-warning" : "bg-success"} px-3 py-2`}>
              {isEditingReport ? "โหมดแก้ไขรายงาน" : "โหมดสร้างรายงานใหม่"}
            </span>
          )}
        </Col>
      </Row>

      {/* สรุปด้านบน */}
      <div className="mt-4 p-3 border rounded">
        <Row className="text-center g-3 align-items-center">
          <Col md={3}><div>งบตามประกาศข้อ 11 (บาท)</div><h5 className="m-0">{fmtMoney(budgetAllowCate)}</h5></Col>
          <Col md={3}><div>ใช้ไป (บาท)</div><h5 className="m-0">{fmtMoney(summarySpendAlowcate)}</h5></Col>
          <Col md={3}><div>คงเหลือ (บาท)</div><h5 className="m-0">{fmtMoney(budgetAllowCate - summarySpendAlowcate)}</h5></Col>
          <Col md={3}><div>ผู้ผ่านการประเมิน (คน)</div><h5 className="m-0">{summaryEvaAlowcate?.toLocaleString()}</h5></Col>
        </Row>
      </div>

      {/* ปุ่มเพิ่ม */}
      <div className="d-flex justify-content-end mt-3">
        <button className="btn btn-success" onClick={openAdd} disabled={!reportMonth}>
          <BsPlusCircle className="me-1" /> เพิ่มรายการจ่าย
        </button>
      </div>

      {/* ตารางหลัก */}
      <div className="mt-3">
        <Table bordered responsive>
          <thead className="table-light">
            <tr>
              <th rowSpan="2" className="text-center align-middle">ลำดับ</th>
              <th rowSpan="2" className="text-center align-middle">สาขาอาชีพ</th>
              <th rowSpan="2" className="text-center align-middle">สาขา</th>
              <th rowSpan="2" className="text-center align-middle">ผู้เข้ารับการประเมิน</th>
              <th rowSpan="2" className="text-center align-middle">ผู้ผ่านการประเมิน</th>
              <th colSpan="5" className="text-center">เงินช่วยเหลือ/อุดหนุน (บาท)</th>
              <th rowSpan="2" className="text-center align-middle">วันที่จ่าย</th>
              <th rowSpan="2" className="text-center align-middle">จัดการ</th>
            </tr>
            <tr>
              <th className="text-center">ค่าตอบแทนผู้ประเมิน</th>
              <th className="text-center">ค่าตอบแทนนอกเวลา</th>
              <th className="text-center">ค่าเดินทาง</th>
              <th className="text-center">ค่าวัสดุ</th>
              <th className="text-center">รวม</th>
            </tr>
          </thead>

          <tbody>
            {flatRows.length === 0 && (
              <tr><td colSpan={13} className="text-center">ยังไม่มีรายการ</td></tr>
            )}

            {flatRows.map((r, idx) => {
              const evalExp = Number(r.evaluatorExpense || 0);
              const compExp = Number(r.compensetionExpense || 0);
              const travExp = Number(r.travellingExpense || 0);
              const matExp  = Number(r.materialExpense || 0);
              const rowSum  = evalExp + compExp + travExp + matExp;

              return (
                <tr key={`${r.id || r.Id}-${idx}`}>
                  <td className="text-center">{idx + 1}</td>

                  {/* 4 คอลัมน์ที่ไม่ merge */}
                  <td className="text-center">{r.lawOccupationName || getLawOccName(r.lawOccupationId)}</td>
                  <td className="text-center">{r.testOccupatioName || r.testOccupationIdName || "-"}</td>
                  <td className="text-center">{(r.personTest ?? 0).toLocaleString()}</td>
                  <td className="text-center">{(r.passEvaluation ?? r.passevaluaTion ?? 0).toLocaleString()}</td>

                  {/* ส่วนที่ merge: แสดงเฉพาะแถวแรกของกลุ่ม */}
                  {r._isFirst && (
                    <>
                      <td className="text-center" rowSpan={r._rowSpan}>{fmtMoney(evalExp)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>{fmtMoney(compExp)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>{fmtMoney(travExp)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>{fmtMoney(matExp)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>{fmtMoney(rowSum)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>{toThaiDateLabel(r.paymentDate)}</td>
                      <td className="text-center" rowSpan={r._rowSpan}>
                        <div className="d-flex gap-2 justify-content-center">
                          <button className="btn btn-sm btn-outline-primary" onClick={() => openEdit(r)}>แก้ไข</button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>

          {flatRows?.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={3} className="text-end fw-bold">รวมใช้ไป</td>
                <td className="text-center fw-bold">{totals.person.toLocaleString()}</td>
                <td className="text-center fw-bold">{totals.pass.toLocaleString()}</td>

                <td className="text-center fw-bold">{fmtMoney(totals.evalTot)}</td>
                <td className="text-center fw-bold">{fmtMoney(totals.compTot)}</td>
                <td className="text-center fw-bold">{fmtMoney(totals.travTot)}</td>
                <td className="text-center fw-bold">{fmtMoney(totals.matTot)}</td>
                <td className="text-center fw-bold">{fmtMoney(totals.sumTot)}</td>

                <td colSpan={2} />
              </tr>
            </tfoot>
          )}
        </Table>
      </div>

      {/* Modal */}
      <Modal isOpen={openModal} toggle={closeModal} centered size="xl" backdrop="static">
        <ModalHeader toggle={closeModal}>
          {editingItem ? "แก้ไขรายการจ่าย" : "เพิ่มรายการจ่าย"}
        </ModalHeader>
        <ModalBody>
          <ItemForm
            mode={editingItem ? "edit" : "add"}
            deptId={deptId}
            reportMonth={reportMonth}
            baseItem={editingItem}
            lawOcuData={lawOcuData}
            onSaved={(savedRows) => {
              if (editingItem) {
                // reload ใหม่ให้ข้อมูลตรง DB เสมอ (แนะนำที่สุด)
                checkAndLoadMonth();
              } else {
                setItems((prev) => [...prev, ...savedRows]);
              }
              closeModal();
            }}
            // ส่ง cache + ฟังก์ชัน preload ให้ dropdown "สาขา"
            testOccCache={testOccCache}
            ensureTestOptions={fetchTestOptionsAtParent}
          />
        </ModalBody>
      </Modal>

      {loading && (
        <div className="position-fixed bottom-0 end-0 p-3">
          <div className="badge bg-secondary">กำลังโหลด...</div>
        </div>
      )}
    </Container>
  );
}

/** ===================== ItemForm ===================== **/
function ItemForm({
  mode,            // "add" | "edit"
  deptId,
  reportMonth,
  baseItem,        // ใช้เมื่อ mode === "edit"
  lawOcuData,
  onSaved,
  testOccCache = {},
  ensureTestOptions, // ฟังก์ชันจาก parent
}) {
  const { y, m } = parseYearMonth(reportMonth || "2000-01");

  const [loadingOptions, setLoadingOptions] = useState({});
  const [isPreloadingTests, setIsPreloadingTests] = useState(false);

  // preload ตัวเลือกสาขาทุก lawOccupationId เมื่อเปิดแก้ไข
  useEffect(() => {
    const ids = Array.from(new Set((baseItem?.detailRows || []).map(r => r.lawOccupationId).filter(Boolean)));
    if (!ids.length || !ensureTestOptions) return;

    let cancelled = false;
    (async () => {
      try {
        setIsPreloadingTests(true);
        await Promise.all(ids.map(async id => {
          setLoadingOptions(s => ({ ...s, [id]: true }));
          await ensureTestOptions(id);
          if (!cancelled) setLoadingOptions(s => ({ ...s, [id]: false }));
        }));
      } finally {
        if (!cancelled) setIsPreloadingTests(false);
      }
    })();

    return () => { cancelled = true; };
  }, [baseItem, ensureTestOptions]);

  // ==== Validation ====
  const detailSchema = Yup.object().shape({
    lawOccupationId: Yup.string().required("เลือกสาขาอาชีพ"),
    testOccupationId: Yup.string().required("เลือกสาขา"),
    personTest: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
    passEvaluation: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
  });

  const schema = Yup.object().shape({
    paymentDate: Yup.string().required("เลือกวันที่จ่าย"),
    evaluatorExpense: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
    compensetionExpense: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
    travellingExpense: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
    materialExpense: Yup.number().typeError("เป็นตัวเลข").min(0).required("กรอกจำนวน"),
    detailRows: Yup.array().of(detailSchema).min(1, "เพิ่มอย่างน้อย 1 แถว"),
  });

  // ==== Initial ====
  const makeEmptyDetail = () => ({
    lawOccupationId: "",
    testOccupationId: "",
    personTest: 0,
    passEvaluation: 0,
    testOccupationLevel: "1",
  });

  const initial = mode === "edit"
    ? {
        id: baseItem?.id || baseItem?.Id || null,
        deptId,
        paymentDate: baseItem?.paymentDate || "",
        evaluatorExpense: baseItem?.evaluatorExpense ?? 0,
        compensetionExpense: baseItem?.compensetionExpense ?? 0,
        travellingExpense: baseItem?.travellingExpense ?? 0,
        materialExpense: baseItem?.materialExpense ?? 0,
        createBy: baseItem?.createBy || "",
        detailRows: Array.isArray(baseItem?.detailRows) && baseItem.detailRows.length > 0
          ? baseItem.detailRows
          : [{
              lawOccupationId: baseItem?.lawOccupationId || "",
              testOccupationId: baseItem?.testOccupationId || "",
              personTest: baseItem?.personTest ?? 0,
              passEvaluation: baseItem?.passEvaluation ?? baseItem?.passevaluaTion ?? 0,
              testOccupationLevel: baseItem?.testOccupationLevel || "1",
            }],
      }
    : {
        id: null,
        deptId,
        paymentDate: "",
        evaluatorExpense: 0,
        compensetionExpense: 0,
        travellingExpense: 0,
        materialExpense: 0,
        createBy: "",
        detailRows: [makeEmptyDetail()],
      };

  // ==== Submit (POST เดียว ส่ง DetailRows) ====
  const handleSubmit = async (values, actions) => {
    try {
      if (!values.paymentDate) {
        Swal.fire("กรุณาเลือกวันที่จ่าย", "", "warning");
        return;
      }
      if (!sameMonth(values.paymentDate, y, m)) {
        Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
        return;
      }
      if (!values.detailRows || values.detailRows.length === 0) {
        Swal.fire("กรุณาเพิ่มอย่างน้อย 1 แถว (สาขาอาชีพ/สาขา/ผู้เข้ารับ/ผู้ผ่าน)", "", "warning");
        return;
      }

      const payload = {
        id: mode === "edit" ? values.id : null,
        deptId,
        evaluatorExpense: Number(values.evaluatorExpense || 0),
        compensationExpense: Number(values.compensetionExpense || 0),
        travellingExpense: Number(values.travellingExpense || 0),
        materialExpense: Number(values.materialExpense || 0),
        paymentDate: values.paymentDate,
        testOccupationLevel: values.detailRows?.[0]?.testOccupationLevel || "1",
        detailRows: values.detailRows.map((d) => ({
          lawOccupationId: d.lawOccupationId,
          testOccupationId: d.testOccupationId,
          personTest: Number(d.personTest || 0),
          passEvaluation: Number(d.passEvaluation || 0),
          testOccupationLevel: d.testOccupationLevel || "1",
        })),
      };

      const res = await fetch("/api/Support/addViewdata48", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const j = await res.json?.() ?? {};

      if (!(j?.status === 1 || j === true)) {
        Swal.fire("บันทึกไม่สำเร็จ", j?.message || "", "warning");
        return;
      }

      const headerId = values.id ?? j.id ?? null;

      // เตรียม row สำหรับอัปเดตทันที (ถ้าไม่ reload)
      const savedRows = values.detailRows.map((d) => {
        const lawName =
          lawOcuData.find((x) => String(x.lawOccupationId) === String(d.lawOccupationId))?.lawOccupationName || "-";
        const testOpts = (testOccCache[d.lawOccupationId] || []);
        const testName =
          testOpts.find((x) => String(x.testOccupationCode) === String(d.testOccupationId))?.testOccupationName || "-";

        return {
          id: headerId,
          deptId,
          lawOccupationId: d.lawOccupationId,
          testOccupationId: d.testOccupationId,
          testOccupationLevel: d.testOccupationLevel || "1",
          personTest: Number(d.personTest || 0),
          passEvaluation: Number(d.passEvaluation || 0),
          evaluatorExpense: Number(values.evaluatorExpense || 0),
          compensetionExpense: Number(values.compensetionExpense || 0),
          travellingExpense: Number(values.travellingExpense || 0),
          materialExpense: Number(values.materialExpense || 0),
          paymentDate: values.paymentDate,
          createBy: values.createBy,
          lawOccupationName: lawName,
          testOccupatioName: testName,
        };
      });

      Swal.fire("บันทึกสำเร็จ", "", "success");
      onSaved && onSaved(savedRows);
    } catch (e) {
      Swal.fire("บันทึกไม่สำเร็จ", "", "error");
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik initialValues={initial} validationSchema={schema} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue, handleChange, errors, touched, isSubmitting }) => {
        const selectedDate = values.paymentDate
          ? utcToZonedTime(new Date(values.paymentDate), "Asia/Bangkok")
          : null;

        const totalCommon =
          Number(values.evaluatorExpense || 0) +
          Number(values.compensetionExpense || 0) +
          Number(values.travellingExpense || 0) +
          Number(values.materialExpense || 0);

        return (
          <Form>
            {/* FieldArray: 4 ช่อง */}
            <FieldArray name="detailRows">
              {({ push, remove }) => (
                <>
                  <div className="d-flex justify-content-end mb-3">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => push({
                        lawOccupationId: "",
                        testOccupationId: "",
                        personTest: 0,
                        passEvaluation: 0,
                        testOccupationLevel: "1",
                      })}
                    >
                      + เพิ่ม
                    </button>
                  </div>

                  <Table bordered responsive>
                    <thead className="table-light">
                      <tr>
                        <th className="text-center align-middle" style={{ width: 60 }}>#</th>
                        <th className="text-center align-middle" style={{ width: 250 }}>สาขาอาชีพ</th>
                        <th className="text-center align-middle" style={{ width: 220 }}>สาขา</th>
                        <th className="text-center align-middle" style={{ width: 140 }}>ผู้เข้ารับการประเมิน</th>
                        <th className="text-center align-middle" style={{ width: 140 }}>ผู้ผ่านการประเมิน</th>
                        <th className="text-center align-middle" style={{ width: 120 }}>จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {values.detailRows.map((row, idx) => {
                        const rowErrors = (errors.detailRows?.[idx] || {});
                        const rowTouched = (touched.detailRows?.[idx] || {});
                        const testOpts = testOccCache[row.lawOccupationId] || [];

                        return (
                          <tr key={idx}>
                            <td className="text-center align-middle">{idx + 1}</td>

                            {/* สาขาอาชีพ */}
                            <td>
                              <Input
                                type="select"
                                name={`detailRows.${idx}.lawOccupationId`}
                                value={row.lawOccupationId}
                                onChange={async (e) => {
                                  handleChange(e);
                                  const id = e.target.value;
                                  if (id) {
                                    // preload รายการสาขาใต้สาขาอาชีพนี้
                                    setLoadingOptions(s => ({ ...s, [id]: true }));
                                    await ensureTestOptions?.(id);
                                    setLoadingOptions(s => ({ ...s, [id]: false }));
                                  }
                                  setFieldValue(`detailRows.${idx}.testOccupationId`, "");
                                }}
                                className={`rounded-pill text-center ${rowTouched.lawOccupationId && rowErrors.lawOccupationId ? "is-invalid" : ""}`}
                              >
                                <option value="">เลือกสาขาอาชีพ</option>
                                {lawOcuData.map((law) => (
                                  <option key={law.lawOccupationId} value={law.lawOccupationId}>
                                    {law.lawOccupationName}
                                  </option>
                                ))}
                              </Input>
                              {rowTouched.lawOccupationId && rowErrors.lawOccupationId && (
                                <div className="invalid-feedback d-block">{rowErrors.lawOccupationId}</div>
                              )}
                            </td>

                            {/* สาขา */}
                            <td>
                              <Input
                                type="select"
                                name={`detailRows.${idx}.testOccupationId`}
                                value={row.testOccupationId}
                                onChange={handleChange}
                                disabled={!row.lawOccupationId || isPreloadingTests || loadingOptions[row.lawOccupationId]}
                                className={`rounded-pill text-center ${rowTouched.testOccupationId && rowErrors.testOccupationId ? "is-invalid" : ""}`}
                              >
                                <option value="">
                                  {(!row.lawOccupationId || isPreloadingTests || loadingOptions[row.lawOccupationId])
                                    ? "กำลังโหลด..." : "เลือกสาขา"}
                                </option>
                                {testOpts.map((it) => (
                                  <option key={it.testOccupationCode} value={it.testOccupationCode}>
                                    {it.testOccupationName}
                                  </option>
                                ))}
                              </Input>
                              {rowTouched.testOccupationId && rowErrors.testOccupationId && (
                                <div className="invalid-feedback d-block">{rowErrors.testOccupationId}</div>
                              )}
                            </td>

                            {/* ผู้เข้ารับการประเมิน */}
                            <td>
                              <Input
                                type="number"
                                min="0"
                                name={`detailRows.${idx}.personTest`}
                                value={row.personTest}
                                onChange={handleChange}
                                className={`rounded-pill text-center ${rowTouched.personTest && rowErrors.personTest ? "is-invalid" : ""}`}
                              />
                              {rowTouched.personTest && rowErrors.personTest && (
                                <div className="invalid-feedback d-block">{rowErrors.personTest}</div>
                              )}
                            </td>

                            {/* ผู้ผ่านการประเมิน */}
                            <td>
                              <Input
                                type="number"
                                min="0"
                                name={`detailRows.${idx}.passEvaluation`}
                                value={row.passEvaluation}
                                onChange={handleChange}
                                className={`rounded-pill text-center ${rowTouched.passEvaluation && rowErrors.passEvaluation ? "is-invalid" : ""}`}
                              />
                              {rowTouched.passEvaluation && rowErrors.passEvaluation && (
                                <div className="invalid-feedback d-block">{rowErrors.passEvaluation}</div>
                              )}
                            </td>

                            {/* จัดการ */}
                            <td className="text-center align-middle">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => remove(idx)}
                                disabled={values.detailRows.length === 1}
                              >
                                - ลบ
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </>
              )}
            </FieldArray>

            {/* ส่วนคอมมอนที่แชร์ทุกแถว */}
            <Row className="g-3">
              <Col md={6}>
                <Label>ค่าตอบแทนผู้ประเมิน (บาท)</Label>
                <Field name="evaluatorExpense">
                  {({ field }) => (
                    <Input type="number" min="0" step="0.01" {...field}
                      className={`rounded-pill text-center ${touched.evaluatorExpense && errors.evaluatorExpense ? "is-invalid" : ""}`} />
                  )}
                </Field>
                {touched.evaluatorExpense && errors.evaluatorExpense && (
                  <div className="invalid-feedback d-block">{errors.evaluatorExpense}</div>
                )}
              </Col>
              <Col md={6}>
                <Label>ค่าตอบแทนนอกเวลาราชการ (บาท)</Label>
                <Field name="compensetionExpense">
                  {({ field }) => (
                    <Input type="number" min="0" step="0.01" {...field}
                      className={`rounded-pill text-center ${touched.compensetionExpense && errors.compensetionExpense ? "is-invalid" : ""}`} />
                  )}
                </Field>
                {touched.compensetionExpense && errors.compensetionExpense && (
                  <div className="invalid-feedback d-block">{errors.compensetionExpense}</div>
                )}
              </Col>
              <Col md={6}>
                <Label>ค่าเดินทางผู้ประเมิน (บาท)</Label>
                <Field name="travellingExpense">
                  {({ field }) => (
                    <Input type="number" min="0" step="0.01" {...field}
                      className={`rounded-pill text-center ${touched.travellingExpense && errors.travellingExpense ? "is-invalid" : ""}`} />
                  )}
                </Field>
                {touched.travellingExpense && errors.travellingExpense && (
                  <div className="invalid-feedback d-block">{errors.travellingExpense}</div>
                )}
              </Col>
              <Col md={6}>
                <Label>ค่าวัสดุใช้ในการประเมิน (บาท)</Label>
                <Field name="materialExpense">
                  {({ field }) => (
                    <Input type="number" min="0" step="0.01" {...field}
                      className={`rounded-pill text-center ${touched.materialExpense && errors.materialExpense ? "is-invalid" : ""}`} />
                  )}
                </Field>
                {touched.materialExpense && errors.materialExpense && (
                  <div className="invalid-feedback d-block">{errors.materialExpense}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>รวม (บาท)</Label>
                <Input type="text" value={totalCommon.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                       readOnly className="rounded-pill text-center" />
              </Col>

              <Col md={6}>
                <Label>วันที่จ่ายเงินช่วยเหลือ/อุดหนุน</Label>
                <DatePicker
                  selected={values.paymentDate ? utcToZonedTime(new Date(values.paymentDate), "Asia/Bangkok") : null}
                  locale="th-buddhist"
                  calendarClassName="thai-buddhist"
                  dateFormat="dd MMMM yyyy"
                  value={values.paymentDate ? toThaiDateLabel(values.paymentDate) : ""}
                  isClearable
                  placeholderText="กรุณาเลือก"
                  onChange={(date) => {
                    if (date instanceof Date && !isNaN(date)) {
                      const y2 = date.getFullYear();
                      const m2 = String(date.getMonth() + 1).padStart(2, "0");
                      const d2 = String(date.getDate()).padStart(2, "0");
                      const iso = `${y2}-${m2}-${d2}`;
                      if (!sameMonth(iso, y, m)) {
                        Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
                        return;
                      }
                      setFieldValue("paymentDate", iso);
                    } else {
                      setFieldValue("paymentDate", "");
                    }
                  }}
                  customInput={
                    <Input
                      type="text"
                      value={values.paymentDate ? toThaiDateLabel(values.paymentDate) : ""}
                      readOnly
                      className={`rounded-pill text-center ${(!values.paymentDate && (touched.paymentDate || false)) ? "is-invalid" : ""}`}
                    />
                  }
                />
                {touched.paymentDate && !values.paymentDate && (
                  <div className="invalid-feedback d-block">กรุณาเลือกวันที่จ่าย</div>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => window.history.back?.()}>
                ยกเลิก
              </button>
              <button type="submit" className="btn btn-success mx-2" disabled={isSubmitting}>
                บันทึก
              </button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
